import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function FirstCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Amar a Deus Sobre Todas as Coisas"}/>

            <p className="info-text">
            Este mandamento pede fé, esperança e caridade em Deus[5]. Deus revela ser único e fiel, e espera que O adoremos com todo o coração[5].<br/>
            O CIC diz que amá-Lo sobre todas as coisas é o primeiro dever: aceitar Seus desígnios (“obediência da fé”) e rejeitar tudo que se oponha a isso[6][7]. <br/>
            Pecados contra este mandamento incluem descrença, idolatria (colocar outras coisas no lugar de Deus) e ingratidão[8][9].<br/>
            O Catecismo enfatiza que, por causa deste mandamento, Jesus resume que devemos amar Deus com toda a alma (Mc 12,29-30)[10].<br/>
            Assim, confiar totalmente em Deus (fé plena), esperar só n’Ele (esperança) e amá-Lo acima de tudo (caridade) são exigidos[5][7].
            </p> 

            <Title text={"Aplicação Cotidiana"}/>

            <p className="info-text">
            Viver este mandamento significa colocar Deus em primeiro lugar em tudo. <br/>
            Exemplos práticos incluem orar diariamente, participar fielmente da missa dominical, usar o nome de Deus com respeito (não como interjeição ou maldição), e não tratar bens terrenos (dinheiro, poder, prazer) como ídolos supremos. <br/>
            Também vale buscar Deus nas decisões: por exemplo, escolher um trabalho ou lazer compatível com a fé, dar graças a Deus nas vitórias e confiar n’Ele nas dificuldades. <br/>
            O CIC alerta que negligenciar Deus leva a desvios morais (Rm 1,28)[6], enquanto a fidelidade a Ele traz paz e esperança.
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
            Este mandamento reflete a revelação de Deus como Criador e Salvador. Deus Se autodenomina “Eu sou o Senhor” (Êxodo), lembrando-nos que só Ele liberta e sustenta a vida[11][12]. <br/>
            Adorar a Deus significa reconhecer Sua infinita dignidade e agradecer pelo dom da criação e da redenção[12]. <br/>
            Teologicamente, o mandamento liga-se às virtudes teologais: sem fé, esperança e caridade não há vida moral verdadeira[5][7]. <br/>
            A Igreja ensina que a adoração a Deus (culto e oração) é o primeiro ato de religião[12]. <br/>
            Desse mandamento brotam todos os outros, pois amar a Deus é a raiz de amar o próximo com amor sincero (caridade)[7]
            </p> 


            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}